export const blockIconsEditorModeComment = (
	<span className='material-symbols-outlined'>mode_comment</span>
);
